const benefits = [
  {
    icon: 'ri-shield-check-line',
    title: 'Vollständige Compliance',
    description: 'Sichere Erfüllung aller nationalen und internationalen Steuerpflichten mit proaktivem Risikomanagement und lückenloser Dokumentation.'
  },
  {
    icon: 'ri-time-line',
    title: 'Zeitersparnis durch Automatisierung',
    description: 'Automatisierte Buchhaltungsprozesse und digitale Schnittstellen reduzieren manuellen Aufwand um bis zu 70% und ermöglichen Fokus auf Ihr Kerngeschäft.'
  },
  {
    icon: 'ri-money-euro-circle-line',
    title: 'Ertragsoptimierung',
    description: 'Umfangreiche betriebswirtschaftliche Kennzahlen zur langfristigen strategischen Planung. Identifizieren Sie Kostentreiber, optimisieren Sie Ihren Ertrag.'
  },
  {
    icon: 'ri-team-line',
    title: 'Persönlicher Ansprechpartner',
    description: 'Dediziertes Team mit tiefem E-Commerce Verständnis, das Ihre Branche kennt und schnelle, fundierte Lösungen für komplexe Fragestellungen bietet.'
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Skalierbare Prozesse',
    description: 'Systeme und Strukturen, die mit Ihrem Wachstum mitwachsen und auch bei internationaler Expansion stabil und transparent bleiben.'
  },
  {
    icon: 'ri-file-chart-line',
    title: 'Transparentes Reporting',
    description: 'Klare Finanzberichte und aussagekräftige KPIs für fundierte Geschäftsentscheidungen mit Echtzeit-Zugriff auf alle relevanten Daten.'
  }
];

const complianceFeatures = [
  'OSS-Verfahren für EU-weiten Handel',
  'Umsatzsteuerregistrierungen in allen EU-Ländern',
  'Intrastat-Meldungen und Zusammenfassende Meldungen',
  'Betriebsprüfungssicherheit durch lückenlose Dokumentation',
  'Internationale Warenbewegungen und Verbringungslisten',
  'Drittstaaten-Handel (UK, Schweiz, USA)'
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] font-semibold text-sm uppercase tracking-wider">Ihre Vorteile</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2F4858] mt-4 mb-6">
            Warum Hommen Consulting?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Als spezialisierter E-Commerce Service Provider bieten wir mehr als klassische Buchführungsservices oder der Steuerberater von Nebenan. Mit fast 20 Jahren Erfahrung im Onlinehandel aus erster Hand kennen wir Ihr Geschäftsumfeld wie kaum ein Zweiter. Von den verschiedenen Warenwirtschafts- oder ERP-Systemen über die Händlerportale der verschiedenenen Marktplätze und Zahlungsdienstleister bis hin zu spezialisierter Multichannel-Software, eine der größten Herausforderungen in der Zusammen mit Onlinehändlern liegt in zerstückelten Systemlandschaften. Wir analyisieren Ihr Geschäftsmodell detailliert und kompetent und unterstützen Sie bei der Auswahl und Implementation geeigneter Schnittstellen in Ihre Systeme und Prozesse, um alle relevanten Daten möglichst automatisiert für Ihre Buchführung aufzubereiten. Auf Wunsch arbeiten wir auch direkt in Ihren Systemen: Ob JTL-Wawi, Billbee, PlentyOne, Amazon Seller Central, eBay Verkäufercockpit oder Otto-Händlerportal, wir finden die Daten, die wir brauchen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#FF6B35]/10 mb-6 group-hover:bg-[#FF6B35] transition-colors">
                <i className={`${benefit.icon} text-3xl text-[#FF6B35] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#2F4858] mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Compliance Section */}
        <div className="bg-gradient-to-br from-[#2F4858] to-[#1e2f3a] rounded-3xl p-12 shadow-2xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-white mb-6">
                Internationale Compliance & Umsatzsteuer
              </h3>
              <p className="text-white/90 text-lg mb-8 leading-relaxed">
                Wir unterstützen Sie vollumfänglich bei der Einhaltung steuerrechtlicher Compliance bei grenzüberschreitendem Handel und internationaler Expansion. Unsere Expertise umfasst alle Aspekte der EU-Umsatzsteuer und Drittstaaten-Handel.
              </p>
              <a href="#contact" className="inline-flex items-center px-8 py-4 bg-[#FF6B35] text-white font-semibold rounded-full hover:bg-[#e55a2a] transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
                Jetzt beraten lassen
                <i className="ri-arrow-right-line ml-2 text-xl"></i>
              </a>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <h4 className="text-xl font-bold text-white mb-6">Unsere Compliance-Leistungen in Kooperation mit unserem Netzwerk internationaler Steuerberatungen:</h4>
              <ul className="space-y-4">
                {complianceFeatures.map((feature, index) => (
                  <li key={index} className="flex items-start text-white/95">
                    <i className="ri-checkbox-circle-fill text-[#FF6B35] mr-3 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}